export default {
	// namespaced: true,
	state: {
		currentRouteData: {},

    requiresAuthOnLoad: true,
	},
	getters: {
		routeData: state => state.currentRouteData,
		routeName: state => state.currentRouteData?.name || '',
		isLobby: (state, getters) => getters.routeName === 'area',
    isAuthRequiredOnLoad: (state) => state.requiresAuthOnLoad,

		ifRequiresAuth: (state,getters) => getters.routeData?.meta?.requiresAuth || false,
		ifSSORedirect: (state,getters) => getters.routeData?.meta?.ssoRedirect,

		getParamValue: (state, getters) => (val) => getters.routeData?.params[val] || false
	},
	mutations: {
    CURRENT_ROUTE(state, value) {
      state.currentRouteData = value
    },

    REQUIRES_AUTH_ON_LOAD(state, value) {
      state.requiresAuthOnLoad = value
    },
	}
}
